import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { useState } from "react";
import { FaXTwitter } from "react-icons/fa6";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  FaWhatsapp,
  FaFacebook,
  FaReddit,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";

import { IClip } from "MVVM/@types";
import { colors } from "theme/colors";
import { CloseButton } from "../../styledComponents";
import { ActiveOverlayPopUpState, KnownState } from "MVVM/State/iframe";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import "./index.css";

export const ShareDialogue = ({ clip }: { clip: IClip }) => {
  const domain = window.location.origin;
  const url = `${domain}/clip/${clip.internalId}`;
  const [activeOverlayPopUp, setActiveOverlayPopUp] = useRecoilState(
    ActiveOverlayPopUpState,
  );
  const ajs_aid = window.rudderanalytics.getAnonymousId();
  const known = useRecoilValue(KnownState);
  const { track } = useAnalyticsContext();

  if (activeOverlayPopUp !== "share") return null;
  return (
    <StyledContainer flexDirection="column" className="share-dialogue">
      <HeaderRow>
        <StyledTitle
          className="share-dialogue-title"
          variant="text.titleXSmall"
        >
          {" "}
          Share this Clip:
        </StyledTitle>
        <CloseButton
          onClick={() => {
            track("Button - Click", {
              locationIdentifier: "share_dialogue_close",
              location: "embeddable_player_overlay",
            });
            setActiveOverlayPopUp(null);
          }}
        />
      </HeaderRow>

      <ShareIconsRow className="share-icons-row">
        <ShareIcon
          className="share-icon"
          $bgColor="#25D366"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_whatsapp",
              location: "embeddable_player_overlay",
            });
            window.open(
              `https://wa.me/?text=${encodeURIComponent(url)}`,
              "_blank",
            );
          }}
        >
          <FaWhatsapp size={24} />
        </ShareIcon>
        <ShareIcon
          className="share-icon"
          $bgColor="#1877F2"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_facebook",
              location: "embeddable_player_overlay",
            });

            window.open(
              `https://www.facebook.com/dialog/share?app_id=595195531196882&display=popup&href=${encodeURIComponent(
                url,
              )}&redirect_uri=${encodeURIComponent(url)}`,
              "_blank",
            );
          }}
        >
          <FaFacebook size={24} />
        </ShareIcon>
        <ShareIcon
          className="share-icon"
          $bgColor="#000000"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_twitter",
              location: "embeddable_player_overlay",
            });
            window.open(
              `https://twitter.com/intent/tweet?url=${url}&text=${clip?.title}`,
              "_blank",
            );
          }}
        >
          <FaXTwitter size={24} />
        </ShareIcon>
        <ShareIcon
          className="share-icon"
          $bgColor="#FF4500"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_reddit",
              location: "embeddable_player_overlay",
            });
            window.open(
              `https://reddit.com/submit?url=${encodeURIComponent(
                url,
              )}&title=${clip?.title}`,
              "_blank",
            );
          }}
        >
          <FaReddit size={24} />
        </ShareIcon>
        <ShareIcon
          className="share-icon"
          $bgColor="#000000"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_tiktok",
              location: "embeddable_player_overlay",
            });
            return window.open(
              `${url}?share=tiktok&ajs_aid=${ajs_aid}`,
              "_blank",
            );
          }}
        >
          <FaTiktok size={24} />
        </ShareIcon>
        <ShareIcon
          className="share-icon"
          $bgColor="#FF0000"
          onClick={() => {
            if (!known) {
              setActiveOverlayPopUp("signup_to_share");
              return;
            }
            track("Button - Click", {
              locationIdentifier: "share_dialogue_youtube",
              location: "embeddable_player_overlay",
            });

            return window.open(
              `${url}?share=youtube&ajs_aid=${ajs_aid}`,
              "_blank",
            );
          }}
        >
          <FaYoutube size={24} />
        </ShareIcon>
      </ShareIconsRow>
    </StyledContainer>
  );
};

const StyledTitle = styled(Text)`
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  width: 100%;
`;

const StyledContainer = styled(Flex)`
  backdrop-filter: blur(4px);
  background: #000000bf;
  border-radius: 12px;
  gap: 24px;
  height: auto;
  padding: 12px;
  pointer-events: auto;
`;

const HeaderRow = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ShareIconsRow = styled(Flex)`
  width: 100%;
  gap: 8px;
  justify-content: center;
`;

const ShareIcon = styled(Flex)<{ $bgColor: string }>`
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  aspect-ratio: 1;
  background: ${(props) => props.$bgColor};
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: center;
  max-width: 52px;
  transition: all 0.2s ease;
  user-select: none;
  width: 52px;

  svg {
    width: 45%;
    height: 45%;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;
